import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

interface MarkAsReadButtonProps {
    onClick: () => void;
    /** Swaps the check for a spinner and blocks repeat clicks. */
    isLoading?: boolean;
    className?: string;
}

/**
 * The green "Mark as read" action, shared by the two places a doctor can
 * clear an unread conversation: the Messages conversation panel header and
 * the Message ODO tab's unread bar.
 *
 * Extracted rather than copied so the two cannot drift into looking like
 * different actions — they do exactly the same thing, and a doctor moving
 * between the two surfaces should recognise it instantly.
 */
const MarkAsReadButton: React.FC<MarkAsReadButtonProps> = ({
    onClick,
    isLoading = false,
    className = ''
}) => (
    <button
        type="button"
        onClick={onClick}
        disabled={isLoading}
        className={`flex items-center gap-1.5 bg-green-600 hover:bg-green-700 text-white text-xs font-semibold px-4 py-2 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
        {isLoading ? (
            <div className="h-3.5 w-3.5 rounded-full border-2 border-white border-t-transparent animate-spin" />
        ) : (
            <CheckCircleIcon className="w-4 h-4" />
        )}
        Mark as read
    </button>
);

export { MarkAsReadButton };
